import styled from 'styled-components';

/** @knipignore - used in website */
export const UserInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  margin-left: 8px;
  width: 100%;
  overflow: hidden;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  justify-content: flex-start;
`;

export const ProfileImagesWrapper = styled.div<{
  size: string;
  $disabled?: boolean;
}>`
  position: relative;
  width: ${({ size }) => size};
  height: ${({ size }) => size};
  ${({ $disabled }) => !$disabled && 'cursor: pointer'};
`;

export const SmallUserImageWrapper = styled.div<{ size?: string }>`
  position: absolute;
  display: flex;
  box-sizing: border-box;
  width: ${({ size }) => size ?? '18px'};
  height: ${({ size }) => size ?? '18px'};
  top: calc(100% - ${({ size }) => size ?? '18px'} * 0.8);
  left: calc(100% - ${({ size }) => size ?? '18px'} * 0.8);
  border-radius: 50%;
  border: 1px solid white;
  box-shadow: 1px 1px 3px 0px #00000040;
`;
